<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">
      <slide>
          <div class="padding">
          <img src="./anOrrery.jpg">
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '4',

  data () {
    return {
      title: 'An Orrery'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
